import { render, staticRenderFns } from "./ZoneTabs.vue?vue&type=template&id=f28b8154&scoped=true"
import script from "./ZoneTabs.vue?vue&type=script&lang=js"
export * from "./ZoneTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28b8154",
  null
  
)

export default component.exports